import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageUSL3 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Brooklyn FC Arrives",
            author: "footballgirl",
            date: "August 31, 2024",
            imageGradient: "linear-gradient(135deg, #ff6b00 0%, #000000 100%)",
            content: `<p>Professional women's soccer returns to New York. Brooklyn FC is ready to make a statement in the USL Super League.</p>`,
            navIndices: { prev: 'usl-2', next: 'usl-4' }
        });
    }

    init() {
        console.log('ArticlePageUSL3 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to USL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'usl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_usl.png';
            leagueLogo.alt = 'USL';
        }
    }
}